/* unplugin-vue-components disabled */import { render } from "./CurrentComponent.vue?vue&type=template&id=4bbf411e&scoped=true"
import script from "./CurrentComponent.vue?vue&type=script&lang=js"
export * from "./CurrentComponent.vue?vue&type=script&lang=js"

import "./CurrentComponent.vue?vue&type=style&index=0&id=4bbf411e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/gh-docs-frontend/gh-docs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbf411e"]])

export default __exports__